//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import urlSrc from '../common/UrlSource'

  export default {
    name: "weather-info",
    props: ['info'],
    data() {
      return {
        imgSrc:  urlSrc.sourceUrl + "weather/" + this.info.weatherPhenomenon + ".png"//天气图标
      }
    },
    methods: {},
    mounted: function () {
      this.$nextTick(() => {
        console.log(this.info)
      });
    }
  }



// WEBPACK FOOTER //
// ./src/components/WeatherInfo.vue